function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGfxEventDeleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 185.42 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 186") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M185.42,64.22a29.26,29.26,0,0,1-4.23,15.22,19.12,19.12,0,0,1-6.86,14.4,23.46,23.46,0,0,1-3.42,2.48l-.15.09-.27.16-.09.05h0c-.39.22-.78.43-1.19.63a26.85,26.85,0,0,1-12,2.76H35.2q-1.46,0-2.89-.12a34.22,34.22,0,0,1-9.9-2.29q-.93-.37-1.82-.79l-.84-.41-.52-.27a30.87,30.87,0,0,1-3-1.84,29.79,29.79,0,0,1-2.56-2A24.39,24.39,0,0,1,4.72,73.81,29.25,29.25,0,0,1,0,57.82,28.89,28.89,0,0,1,28.69,28.72c.49,0,1,0,1.46,0h.21A49.43,49.43,0,0,1,40.89,16.36C52.6,6.32,69.71,0,88.77,0c16,0,30.66,4.47,41.87,11.84a28.23,28.23,0,0,1,13.93-3.65,28.89,28.89,0,0,1,28.69,29.09,30,30,0,0,1-.16,3A29.17,29.17,0,0,1,185.42,64.22Z",
    style: {
      fill: "#6c63ff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M82.6,84.77H32.26s-1-15,5-15.14,5.36,6.63,12.93-2.72,16.75-8.84,17.94-3.32-2.3,9.95,4.08,8.59S87.78,74.4,82.6,84.77Z",
    style: {
      fill: "#3fa9f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.58,84.78h-.17c.4-9.85,2.46-16.18,4.12-19.76a17.94,17.94,0,0,1,3.56-5.47l.11.13a17.81,17.81,0,0,0-3.52,5.43C59,68.65,57,75,56.58,84.78Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8,84.8l-.16,0A26.38,26.38,0,0,1,81.27,73.7l.11.13A26.2,26.2,0,0,0,74.8,84.8Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.18,84.78l-.17,0a18.52,18.52,0,0,0-1.67-10.83,14.91,14.91,0,0,0-2.63-3.84l.12-.12a15.09,15.09,0,0,1,2.66,3.88A18.69,18.69,0,0,1,40.18,84.78Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.43,85H26.83v-.21c0-.53-.83-13,3.2-17.41a4.42,4.42,0,0,1,3.23-1.55,9.6,9.6,0,0,1,5.61,1.7C41.36,69,43,70,49,62.55c6.53-8.08,13.58-9.81,17.63-8.85a6.29,6.29,0,0,1,5,4.84,21.48,21.48,0,0,1,.21,6.26c-.14,1.88-.25,3.36.53,4s1.93.61,4,.16c4.3-.92,10.29-.13,13.3,3.76,1.62,2.09,2.89,5.89-.22,12.13Zm-62.17-.46H89.15c2.32-4.71,2.4-8.7.21-11.52-2.76-3.57-8.55-4.51-12.85-3.59-2.3.49-3.66.41-4.43-.26-.94-.82-.83-2.4-.68-4.4a21.1,21.1,0,0,0-.2-6.13,5.85,5.85,0,0,0-4.61-4.49c-3.92-.94-10.78.78-17.18,8.69-6.28,7.76-8.17,6.64-10.79,5.09a9.12,9.12,0,0,0-5.37-1.64,4,4,0,0,0-2.9,1.4C26.72,71.67,27.16,82.86,27.25,84.54Z",
    style: {
      fill: "#cfcce0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1,52.93l-18.21-3.17c3.26-6.75,4.74-13.42,3.47-20L124.58,33A40.46,40.46,0,0,0,121.1,52.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.58,
    y: 30.43,
    width: 0.45,
    height: 9.58,
    transform: "translate(60.43 142.29) rotate(-80.14)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.27,
    y: 32.19,
    width: 0.45,
    height: 9.58,
    transform: "translate(58.45 143.45) rotate(-80.14)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.97,
    y: 33.95,
    width: 0.45,
    height: 9.58,
    transform: "translate(56.47 144.6) rotate(-80.14)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.66,
    y: 35.7,
    width: 0.45,
    height: 9.58,
    transform: "translate(54.49 145.76) rotate(-80.14)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.36,
    y: 37.46,
    width: 0.45,
    height: 9.58,
    transform: "translate(52.51 146.91) rotate(-80.14)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.05,
    y: 39.21,
    width: 0.45,
    height: 9.58,
    transform: "translate(50.52 148.06) rotate(-80.14)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.75,
    y: 40.97,
    width: 0.45,
    height: 9.58,
    transform: "translate(48.54 149.22) rotate(-80.14)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.44,
    y: 42.72,
    width: 0.45,
    height: 9.58,
    transform: "translate(46.56 150.37) rotate(-80.14)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.22,59.35,111,56.18c3.26-6.75,4.74-13.42,3.47-20l18.21,3.17A40.46,40.46,0,0,0,129.22,59.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.69,
    y: 36.85,
    width: 0.45,
    height: 9.58,
    transform: "translate(60.84 155.6) rotate(-80.14)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.39,
    y: 38.6,
    width: 0.45,
    height: 9.58,
    transform: "translate(58.86 156.75) rotate(-80.14)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.08,
    y: 40.36,
    width: 0.45,
    height: 9.58,
    transform: "matrix(0.17, -0.99, 0.99, 0.17, 56.87, 157.91)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.78,
    y: 42.11,
    width: 0.45,
    height: 9.58,
    transform: "matrix(0.17, -0.99, 0.99, 0.17, 54.89, 159.06)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.47,
    y: 43.87,
    width: 0.45,
    height: 9.58,
    transform: "translate(52.91 160.22) rotate(-80.14)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.16,
    y: 45.62,
    width: 0.45,
    height: 9.58,
    transform: "translate(50.93 161.37) rotate(-80.14)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.86,
    y: 47.38,
    width: 0.45,
    height: 9.58,
    transform: "translate(48.94 162.52) rotate(-80.14)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.55,
    y: 49.14,
    width: 0.45,
    height: 9.58,
    transform: "translate(46.96 163.68) rotate(-80.14)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.18,84.76H101.69v-.18l-1.55-44.36h35.6Zm-32.12-.38h31.76l1.53-43.79H100.53Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.4 82.37 103.47 82.37 102.08 42.6 133.79 42.6 132.4 82.37",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.97,
    y: 48.43,
    width: 2.47,
    height: 30.58,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.7,
    y: 48.43,
    width: 2.47,
    height: 30.58,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.43,
    y: 48.43,
    width: 2.47,
    height: 30.58,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 133.85,
    y: 14.46,
    width: 6.18,
    height: 47.56,
    transform: "matrix(0.53, -0.85, 0.85, 0.53, 31.44, 133.55)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.68,29.17a7.25,7.25,0,0,0-11.06,7.18l1.92,1.22A5.72,5.72,0,1,1,139,41l1.92,1.22a7.25,7.25,0,0,0,1.74-13.07Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6,42,80,32.06C85.66,27.1,89.62,21.53,91,15l15.56,10A40.46,40.46,0,0,0,95.6,42Z",
    style: {
      fill: "#3fa9f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.44,
    y: 18.48,
    width: 0.45,
    height: 9.58,
    transform: "translate(24.86 92.04) rotate(-57.3)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.47,
    y: 19.98,
    width: 0.45,
    height: 9.58,
    transform: "translate(23.15 91.92) rotate(-57.3)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.51,
    y: 21.48,
    width: 0.45,
    height: 9.58,
    transform: "translate(21.45 91.8) rotate(-57.3)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.55,
    y: 22.98,
    width: 0.45,
    height: 9.58,
    transform: "translate(19.75 91.68) rotate(-57.3)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.59,
    y: 24.48,
    width: 0.45,
    height: 9.58,
    transform: "translate(18.04 91.56) rotate(-57.3)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.62,
    y: 25.98,
    width: 0.45,
    height: 9.58,
    transform: "translate(16.34 91.44) rotate(-57.3)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.66,
    y: 27.48,
    width: 0.45,
    height: 9.58,
    transform: "translate(14.63 91.32) rotate(-57.3)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.7,
    y: 28.98,
    width: 0.45,
    height: 9.58,
    transform: "translate(12.93 91.2) rotate(-57.3)",
    style: {
      fill: "#3f3d56"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGfxEventDeleted);
export default __webpack_public_path__ + "static/media/gfx-event-deleted.4fef2dae4b69f1d9590ba3f27728aa14.svg";
export { ForwardRef as ReactComponent };